export const SELECT_COMPANY = "SELECT_COMPANY";
export const UPDATE_COMPANY_STATUS = "UPDATE_COMPANY_STATUS";
export const FETCH_MEDICO_DATA = "FETCH_MEDICO_DATA";
